<template>
  <div class="edit-platform">
    <!--标题-->
    <div class="breadcrumb" style="background: #fff">申请扣款</div>
    <div class="order-detail-basic">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" hide-required-asterisk label-width="100px" class="demo-ruleForm">
        <el-form-item label="平台号:" prop="num">
          <el-autocomplete v-model="code" :fetch-suggestions="querySearchAsync" placeholder="请输入内容" :trigger-on-focus="false" @select="handleSelect">
          </el-autocomplete>
          <el-button @click="verifyStore" style="margin-right:10px" round>验证平台</el-button>
        </el-form-item>
        <el-form-item label="平台名称:">
          <el-input v-model="storeName" disabled clearable></el-input>
        </el-form-item>
        <el-form-item label="扣款金额:" prop="amount">
          <el-input type="number" v-model="ruleForm.amount" clearable></el-input>
        </el-form-item>
        <el-form-item label="支付方式:">
          <el-select v-model="ruleForm.accountType" placeholder="请选择">
            <el-option v-for="(v, k) in $config.accountType" :key="k" :label="v" :value="k"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注:">
          <el-input v-model="ruleForm.remark" clearable></el-input>
        </el-form-item>
      </el-form>
      <div class="edit-button">
        <el-button type="primary" round @click="submitForm('ruleForm')" :loading="loading">申请扣款</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { adminDeductApply, getByStoreIds } from '@/api/epay'
import { storeQueryListByCode, storeQueryByStoreCode, getByStoreId } from '@/api/crm'

export default {
  name: 'edit-platform',
  components: {
  },
  data () {
    // 校验扣款金额
    var checkAmount = (rule, value, callback) => {
      // const regAmount = /^[1-9]\d*$/
      const regAmount = /^(?!0+(?:\.0+)?$)(?:[1-9]\d*|0)(?:\.\d{1,2})?$/
      if (value === '') {
        callback(new Error('请输入扣款金额'))
      } else if (regAmount.test(value)) {
        return callback()
      } else {
        callback(new Error('请输入正数且小数点后精度两位'))
      }
    }
    var accountType = (rule, value, callback) => {
      if (this.ruleForm.amount !== '0' && !this.ruleForm.accountType) {
        callback(new Error('请选择支付方式'))
      } else {
        callback()
      }
    }
    return {
      loading: false,
      awsSdk: null,
      show: false,
      storeName: '',
      ruleForm: {
        accountType: '',
        amount: '',
        remark: '',
        storeId: ''
      },
      rules: {
        amount: [
          { validator: checkAmount, trigger: 'change' }
        ],
        accountType: [
          // { validator: accountType, trigger: 'change' }
          { required: true, message: '请选择支付方式', trigger: 'change' }
        ]
      },
      date: '',
      code: '',
      id: '',
      bankList: []
    }
  },
  watch: {
    code () {
      this.storeName = ''
      this.show = false
    }
  },
  mounted () {
    sessionStorage.setItem('searchFlag', true)
  },
  methods: {
    // 验证平台
    verifyStore () {
      if (!this.code) {
        this.$message.error('请输入验证平台')
        return
      }
      storeQueryByStoreCode(this.code).then(res => {
        if (res.data.data.exist) {
          this.ruleForm.storeId = res.data.data.id
          this.storeName = res.data.data.name
          this.show = true
        } else {
          this.$message.error('平台不存在')
        }
      })
    },
    submitForm (formName) {
      if (!this.show) {
        this.$message.error('请验证平台')
        return
      }
      this.$refs[formName].validate((valid) => {
        console.log(this.ruleForm, 'formName')
        if (valid) {
          if (!this.ruleForm.amount) {
            this.$message({
              message: '请输入扣款金额',
              type: 'error'
            })
            return
          };
          if (!this.ruleForm.accountType) {
            this.$message({
              message: '请选择支付方式',
              type: 'error'
            })
            return
          };
          let balance = ''
          getByStoreIds(this.ruleForm.storeId).then(res => {
            if (this.ruleForm.accountType === 'ACCT') {
              balance = Number(res.data.data.balances.ACCT.balance)
              // + Number(res.data.balances.standbyCreditLine)
            } else if (this.ruleForm.accountType === 'BONUS') {
              balance = res.data.data.balances.BONUS.balance
            } else {
              balance = res.data.data.balances.SETTLE.balance
            }
            console.log(this.ruleForm.amount, Number(balance))
            if (this.ruleForm.amount > Number(balance) && res.data.standbyCreditLine !== 0) {
              this.$message({
                message: '扣款金额不能大于实际金额',
                type: 'error'
              })
            } else {
              this.loading = true
              adminDeductApply(this.ruleForm).then(res => {
                if (res.data.success) {
                  this.$message({
                    message: '申请成功',
                    type: 'success'
                  })
                  this.$router.go(-1)
                  this.loading = false
                }
              })
            }
          })
        }
      })
    },
    handleSelect (item) {
      this.ruleForm.storeId = item.id
    },
    querySearchAsync (queryString, cb) {
      storeQueryListByCode(queryString).then(res => {
        res.data.data.forEach(item => {
          item.value = item.code
        })
        cb(res.data.data)
      })
    }
  }
}
</script>
<style scoped lang="less">
// @import "index";
.edit-platform {
  .el-input {
    @{deep} .el-input__inner {
      //color: #F56C6C;
      -moz-appearance: textfield;
    }

    @{deep} .el-input__inner::-webkit-inner-spin-button,
    @{deep} .el-input__inner::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }
}

@deep: ~">>>";
</style>
